import { InspectorControls, useBlockProps } from "@wordpress/block-editor";
import {
	PanelBody,
	RangeControl,
} from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { Fragment } from "react";
import { TaxonomyTermsSelect } from "../../components/taxonomy-terms-select/taxonomy-terms-select";
import ServerSideRender from "@wordpress/server-side-render";
import { withSelect } from "@wordpress/data";
import { compose } from "@wordpress/compose";

import './editor.scss';

export function Edit(props) {
	const { attributes, setAttributes, categories } = props;
	const blockProps = useBlockProps();

	return (
		<Fragment>
			<InspectorControls>
				<PanelBody
					title={__("Query settings", "a3web-blocks")}
					initialOpen={true}
				>
					<RangeControl
						label={__("Nombre de posts dans le slider", "a3web-blocks")}
						value={attributes.perPage}
						onChange={(perPage) => setAttributes({ perPage })}
						min={1}
						max={10}
					/>

					<TaxonomyTermsSelect
						terms={categories}
						selectedTerm={attributes.terms}
						selectTerm={(categoryId) => setAttributes({ terms: categoryId })}
						label="Catégorie"
					/>
				</PanelBody>
			</InspectorControls>

			<Fragment>
				<div {...blockProps}>
					<ServerSideRender
						block="a3web-blocks/posts"
						attributes={{
							terms: attributes.terms,
                            perPage: attributes.perPage
						}}
					/>
				</div>
			</Fragment>
		</Fragment>
	);
}

const applyWithSelect = withSelect((select) => {
	return {
		categories: select("core").getEntityRecords("taxonomy", "category", {
			per_page: -1,
		}),
	};
});

export default compose(applyWithSelect)(Edit);
